import app from "js/legacy-app";

app.directive('loadingIndicator', [function () {
    return {
        template: '<md-progress-circular md-mode="indeterminate" class="md-hue-3" md-diameter="60"></md-progress-circular>'
    };
}]);
